<template>
  <div class="footer">
    <!-- <img class="footerLogo" @click="toAboutUs" src="@/assets/PC/footer/footerLogo.png" alt=""> -->
    <div class="footerLogo" @click="toAboutUs">Aurora</div>
    <div class="infoItem">
      <span>
        {{$t('footer.addressLabel')}}
        <span style="margin-left:8px;">{{$t('footer.addressValue')}}</span>
      </span>
    </div>
    <div class="infoItem">
      <span class="itemTitle">
        {{$t('contactUs.zhAddress')}}
      </span>
      <span>
        {{$t('contactUs.address1')}}
      </span>
    </div>
    <div class="infoItem">
      <span class="itemTitle">
        {{$t('contactUs.enAddress')}}
      </span>
      <span>
        {{$t('contactUs.address2')}}
      </span>
    </div>
  <div class="QRCode">
    <img src="@/assets/PC/footer/QRCode.png" alt="">
    <span>{{$t('contactUs.watch')}}</span>
  </div>
  </div>
</template>

<script>
export default {
  name: 'footerPage',
  methods: {
    toAboutUs () {
      if (this.$route.name === 'aboutUs') {
        window.scrollTo(0, 0)
      } else {
        this.$router.push({
          name: 'aboutUs'
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.footer {
  padding: 0.43rem 0.43rem 0.53rem 0.43rem;
  background-color: #252525;
  text-align: left;
  font-family: NotoSans, sans-serif;
  font-weight: 400;
}
.footerLogo {
  // width: 1.41rem;
  // height: 1.33rem;
  font-size: 0.53rem;
  color: #fff;
  margin: 0.27rem 0;
  font-weight: 600;
}
.infoItem {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.43rem;
  .itemTitle {
    margin-bottom: 0.16rem;
  }
  img {
    width: 0.53rem;
    height: 0.53rem;
    margin-right: 0.21rem;
  }
  span {
    color: #fff;
    font-size: 0.37rem;
  }
}
.QRCode {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  img {
    width: 2.13rem;
    height: 2.13rem;
    margin-bottom: 0.16rem;
  }
  span {
    color: #fff;
    font-size: 0.37rem;
  }
}
</style>
